<style src="css/login.css" scoped></style>
<template>
  <div class="bgImg">
    <img class="loginLogo" :src="EnvUrl+logo" alt="">
    <div v-if="forgetStatus===1" class="contentBox">
      <div class="inputBox">
        <!--                <div class="iconNumber"></div>-->
        <input type="text" autocomplete="off" :placeholder="placeholder1" v-model="studentNo">
      </div>
      <div class="inputBox">
        <!--                <div class="iconCard"></div>-->
        <input :type="type" autocomplete="new-password" :placeholder="placeholder2" v-model="studentCard">
        <div class="iconEye" :class="{active:type==='text'}" @click="show"></div>
      </div>
      <div class="forgetBox" v-if="showForgetBox">
        <span @click="forget(2)">忘记密码？</span>
        <!--                <span @click="forget(3)">注册？</span>-->
      </div>
      <div class="loginBtn" :class="{active:studentNo&&studentCard}" @click="login">登 录</div>
      <div class="forget" v-if="showForgetBox" @click="forget(3)">注 册</div>
    </div>
    <div v-else-if="forgetStatus===2">
      <div class="inputBox">
        <!--                <div class="iconNumber"></div>-->
        <input type="text" autocomplete="off" placeholder="请输入手机号" v-model="userPhone">
      </div>
      <div class="inputBox codeBox">
        <div class="codeLeft">
          <!--                    <div class="iconCard"></div>-->
          <input style="width: 2.2rem" autocomplete="new-password" placeholder="请输入验证码" v-model="code">
        </div>
        <div class="getCode" v-if="status===0" @click="getSmsAuthCode">获取验证码</div>
        <div class="getCode" v-if="status===1">重新获取({{ num }})</div>
        <div class="getCode" v-if="status===2" @click="getSmsAuthCode">重新获取</div>
      </div>
      <div class="inputBox">
        <!--                <div class="iconCard"></div>-->
        <input :type="type" autocomplete="new-password" placeholder="请重置密码" v-model="userPsw">
        <div class="iconEye" :class="{active:type==='text'}" @click="show"></div>
      </div>
      <div class="forgetBox" @click="forget(1)">返回登录</div>
      <div class="loginBtn" @click="changeDoctorPsw">重置密码</div>
    </div>
    <div v-else>
      <div class="inputBox">
        <!--                <div class="iconNumber"></div>-->
        <input type="text" autocomplete="off" placeholder="请输入手机号" v-model="userPhone">
      </div>
      <div class="inputBox codeBox">
        <div class="codeLeft">
          <!--                    <div class="iconCard"></div>-->
          <input style="width: 2.2rem" autocomplete="new-password" placeholder="请输入验证码" v-model="code">
        </div>
        <div class="getCode" v-if="status===0" @click="getSmsAuthCode">获取验证码</div>
        <div class="getCode" v-if="status===1">重新获取({{ num }})</div>
        <div class="getCode" v-if="status===2" @click="getSmsAuthCode">重新获取</div>
      </div>
      <div class="inputBox">
        <!--                <div class="iconCard"></div>-->
        <input :type="type" autocomplete="new-password" placeholder="请设置密码" v-model="userPsw">
        <div class="iconEye" :class="{active:type==='text'}" @click="show"></div>
      </div>
      <div class="forgetBox" @click="forget(1)">返回登录</div>
      <div class="loginBtn" @click="doScaleUserLogin">注册</div>
    </div>


  </div>
</template>
<script>
import {getSource, getSources} from "../api"
import topbar from 'components/topbar'

import noMoreData from 'components/no-more-data'


export default {
  data() {
    return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      forgetStatus: 1,
      studentNo: '',
      studentCard: '',
      openid: '',
      type: 'password',
      num: 59,
      status: 0,
      userPhone: '',
      userPsw: '',
      code: '',
      loginType: localStorage.getItem('loginType') ? localStorage.getItem('loginType') : 1,
      placeholder1: localStorage.getItem('loginType') == 0 ? '请输入学号' : '请输入账号',
      placeholder2: localStorage.getItem('loginType') == 0 ? '请输入身份证号' : '请输入密码',
      logo: 'ysqx-logo.jpg',
      showForgetBox: false,
      id: localStorage.getItem('id') ? localStorage.getItem('id') : '1001'
    }
  },
  components: {
    topbar,
    noMoreData,
  },
  computed: {},
  methods: {
    forget(n) {
      this.userPhone = ''
      this.userPsw = ''
      this.code = ''
      this.studentNo = ''
      this.studentCard = ''
      this.forgetStatus = n
    },
    show() {
      if (this.type == 'password') {
        this.type = 'text'
      } else {
        this.type = 'password'
      }

    },
    loginSuccess() {

      if (this.$route.query.next) {
//                    location.href =
        this.$router.replace(`${this.$route.query.next}`)
//                    console.log(this.$route)
      } else {
        this.$router.replace(`/`)
      }
    },
    getCookie(key) {
      let cookieStr = document.cookie.split("; ");
      for (let i = 0; i < cookieStr.length; i++) {
        let tempArr = cookieStr[i].split("=");
        if (tempArr[0] == key) {
          return tempArr[1];
        }
      }
      return null;
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      console.info(cname + "=" + cvalue + "; " + expires);
      document.cookie = cname + "=" + cvalue + "; " + expires;
      console.info(document.cookie);
    },
    async login() {

      if (!this.studentNo) {
        alert("请输入账号");
        return;
      }
      if (!this.studentCard) {
        alert("请输入密码");
        return;
      }
      let data = await getSources("/bear-scale/api/scaleUserInfo/login.json", {
        mobile: this.studentNo,
        password: this.studentCard,
        cpyCode: this.$route.query.cpy_code || ''
      });
      if (data.status === 0) {
        localStorage.setItem('studentNo', this.studentNo);
        localStorage.setItem('studentCard', this.studentCard);
        localStorage.setItem('userId', data.data.userId);
        localStorage.setItem('nickName', data.data.nickName);
        localStorage.setItem('companyId', data.data.companyId ? data.data.companyId : '1001');
        localStorage.setItem('userPhone', data.data.userPhone ? data.data.userPhone : '');

        this.loginSuccess();

      } else {
        alert(data.msg);
      }
    },
    handle() {
      let aa = this.$route.query.next.slice(2)
      console.log(aa)
      var url_ll = aa.split('&'), obj = {};
      url_ll.forEach((item, idx) => {
        var key = item.split('=')[0];
        var val = item.split('=')[1];
        obj[key] = val;
      })
      console.log(obj)
      if (obj.id && obj.token) {
        this.forScaleUserLogin(obj.id, obj.token)
        this.id = obj.id
      }
      console.log(this.id)
    },
    async changeDoctorPsw() {
      let data = await getSources("/bear-scale/api/scaleUserInfo/changeUserPsw.json", {
        userPhone: this.userPhone,
        code: this.code,
        userPsw: this.userPsw,
        companyId: localStorage.getItem('id') ? localStorage.getItem('id') : ''
      });
      if (data.status === 0) {
        alert(`重置成功~`)
        this.forget(1)
      } else {
        alert(data.msg)
      }
    },
    async doScaleUserLogin() {
      let data = await getSources("/bear-scale/api/scaleUserInfo/doScaleUserLogin.json", {
        userPhone: this.userPhone,
        code: this.code,
        userPsw: this.userPsw,
        type: 1,
        companyId: localStorage.getItem('id') ? localStorage.getItem('id') : ''
      });
      if (data.status === 0) {
        alert(`注册成功`)
        this.forget(1)
      } else {
        alert(data.msg)
      }
    },
    async getSmsAuthCode() {
      if (!this.userPhone) {
        alert('请先输入手机号')
        return
      }
      let data = await getSources("/bear-scale/api/scaleUserInfo/getSmsAuthCode.json", {userPhone: this.userPhone});
      if (data.status === 0) {
        alert('发送成功')
        this.status = 1
        this.num = 59

        // this.$nextTick(() => {
        // 	this.$refs.code.focus()
        // })

        const that = this

        setTimeout(function codeFormat() {
          that.num--

          if (that.num) {
            setTimeout(codeFormat, 1000)
          } else {
            that.status = 2
          }
        }, 1000)


        return
      } else {
        alert(data.msg)
      }
    },
    async forScaleUserLogin(id, token) {
      let data = await getSources("/bear-scale/api/scaleUserInfo/forScaleUserLogin.json", {
        id: id,
        token: token
      });
      if (data.status === 0) {
        localStorage.setItem('loginType', data.loginType)
        localStorage.setItem('companyLogo', data.companyLogo)
        // localStorage.setItem('token',this.token)
        // localStorage.setItem('id',this.id)
        if (data.loginType == 0) {
          this.placeholder1 = '请输入学号';
          this.placeholder2 = '请输入身份证号';
        } else {
          this.placeholder1 = '请输入账号';
          this.placeholder2 = '请输入密码';
        }
        this.logo = data.companyLogo
      } else {
        alert(data.msg)
      }

    },
    get() {
      setTimeout(() => {
        this.loginType = localStorage.getItem('loginType') ? localStorage.getItem('loginType') : 1;
        this.placeholder1 = localStorage.getItem('loginType') == 0 ? '请输入学号' : '请输入账号';
        this.placeholder2 = localStorage.getItem('loginType') == 0 ? '请输入身份证号' : '请输入密码';
        // this.logo = localStorage.getItem('companyLogo') ? localStorage.getItem('companyLogo') : 'bear_logo_144_144.png';
        this.showForgetBox = localStorage.getItem('loginType') == 0 ? false : true
      }, 500)
    }
  },
  mounted() {
    console.log(this.$route.query.loginType)
    // if(this.$route.query.loginType>1){
    //     this.placeholder1='请输入账号'
    //     this.placeholder2='请输入密码'
    // }else{
    //     console.log(22222222)
    //     if(localStorage.getItem('loginType')>1){
    //         this.placeholder1='请输入账号'
    //         this.placeholder2='请输入密码'
    //     }
    // }
    if (localStorage.getItem("studentNo") && localStorage.getItem("studentCard")) {
      this.studentNo = localStorage.getItem("studentNo");
      this.studentCard = localStorage.getItem("studentCard");
    } else {
      console.log("wu");
    }
    if (this.$route.query.next) {
      this.handle()
    }
    this.get()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login.vue?07777086